<template>
  <div>
    <CartPanel v-if="showFloat" @toggle="toggle" />
    <van-popup
      v-if="!isDesktop"
      position="bottom"
      v-model="show"
      round
      close-on-popstate
      class="inset-x-0 z-[999999999999] mx-auto max-h-[82vh] max-w-screen-sm overflow-hidden rounded-t-2xl"
    >
      <CartList />
    </van-popup>
  </div>
</template>

<script>
import CartList from "@/components/cart/CartList";

import CartPanel from "@/components/cart/CartPanel.vue";
import { mapGetters } from "vuex";
import desktop from "@/mixins/desktop";
import { closeOverlayOnEscape } from "@/utils/overlayClose";

export default {
  mixins: [desktop],
  components: { CartList, CartPanel },
  data() {
    return {
      show: false,
      show_cart: false,
    };
  },
  mounted() {
    this.$root.$on("toggle-cart", this.toggle);
    if (typeof window !== "undefined") {
      window.addEventListener("keydown", this.onOverlayKeydown);
    }
  },
  beforeDestroy() {
    this.$root.$off("toggle-cart", this.toggle);
    if (typeof window !== "undefined") {
      window.removeEventListener("keydown", this.onOverlayKeydown);
    }
  },
  methods: {
    toggle() {
      if (this.atCheckout || this.atConfirm) return false;
      if (this.isDesktop) {
        const onCart = this.$route.name && this.$route.name.indexOf("order-cart") === 0;
        if (onCart) return false;
        if (this.$track && this.hasItems) {
          this.$track.viewCart({
            value: this.amount,
            items: this.items,
          });
        }
        this.$router.push(this.localePath("/order/cart"));
        return;
      }
      const nextShow = !this.show;
      this.show = nextShow;

      if (nextShow && this.$track && this.hasItems) {
        this.$track.viewCart({
          value: this.amount,
          items: this.items,
        });
      }
    },
    close() {
      this.show = false;
    },
    onOverlayKeydown(event) {
      closeOverlayOnEscape(event, this.show, this.close);
    },
  },
  computed: {
    ...mapGetters({
      amount: "cart/amount",
      hasItems: "cart/hasItems",
      items: "cart/items",
    }),
    atCheckout() {
      return this.$route.name?.match("order-checkout");
    },
    atConfirm() {
      return this.$route.name?.match("order-confirm");
    },
    showFloat() {
      const name = this.$route.name?.replace(`___${this.$i18n.locale}`, "");
      return ["index", "order"].includes(name);
    },
  },
};
</script>
